module.exports = __webpack_public_path__ + "img/hero-network.de661ac7.png";